module.exports = __webpack_public_path__ + "img/1x.0b3a97d.jpg";